<template>
  <div class="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
    <div class="md:flex md:items-center md:justify-between md:space-x-4 xl:border-b xl:pb-6">
      <div>
        <h1 class="text-2xl font-bold text-gray-900">
            Start your own tour guide company
        </h1>
        <p class="mt-2 text-sm text-gray-500">
            Need help starting your own company? Read more in the links below on establishing a company where you resid
        </p>
      </div>
    </div>
    <div v-for="country in countries" class="py-3 xl:pt-6 xl:pb-0">
      <h2 class="pt-8 text-2xl font-semibold text-gray-900">
        {{ country.country }}
      </h2>
      <div class="prose text-base mt-5 max-w-none">
        <p>{{ country.text }}</p>
          <a href="{{ country.link }}" class="flex flex-wrap overflow-hidden text-sm text-gray-500 hover:text-gray-700">
              {{ country.link }}
          </a>
      </div>
    </div>
  </div>
</template>

<script>
import LandingLayout from '../Layouts/LandingLayout.vue';

const countries = [
    {
        country: 'Norway',
        text: 'Registering with The Brønnøysund Register Center',
        link: 'https://www.brreg.no/en/limited-company/how-to-start-a-limited-company/starting-the-company/'
    },
    {
        country: 'Sweden',
        text: 'Registering with Bolagsverket, Swedish Companies Registration Office',
        link: 'https://bolagsverket.se/en/foretag/aktiebolag/startaaktiebolag.479.html'
    },
    {
        country: 'Denmark',
        text: 'Registering with Business in Denmark - Services Contact Point',
        link: 'https://businessindenmark.virk.dk/guidance/services-contact-point/Establish-a-business-in-Denmark/'
    },
]

export default {
  layout: LandingLayout,
  props: {

  },
    data() {
      return {
          countries
      }
    }
};
</script>
